/**
 * Shared Preact context objects for the Drive UI.
 * Kept in a separate file to avoid circular imports between DriveApp and its children.
 */

import { createContext } from 'preact'
import { useContext } from 'preact/hooks'

export const DriveStoreContext = createContext(null)
export const DriveI18nContext  = createContext(null)
export const DriveUiContext    = createContext({ canUpdate: false, openRename: () => {}, requestMove: () => {} })

export function useDriveStore() {
  return useContext(DriveStoreContext)
}

export function useDriveI18n() {
  return useContext(DriveI18nContext)
}

export function useDriveUi() {
  return useContext(DriveUiContext)
}
